import { render, staticRenderFns } from "./Addbussiness.vue?vue&type=template&id=324bb837&scoped=true"
import script from "./addbussiness.js?vue&type=script&lang=js&external"
export * from "./addbussiness.js?vue&type=script&lang=js&external"
import style0 from "./addbussiness.scss?vue&type=style&index=0&id=324bb837&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324bb837",
  null
  
)

export default component.exports